import React from 'react'
import UPSCExamPattern from '../components/about/UPSCExamPattern'
import BookList from '../components/about/BookList'
import AnnualCalendar from '../components/about/AnnualCalender'
import Commen from '../components/about/Commen'
import Faq from '../components/about/Faq'
import UpscMainsPattern from '../components/about/UpscMainsPattern'

function Aboutpage() {
  return (
    <div>
      <UPSCExamPattern/>
      <UpscMainsPattern/>
      <BookList/>
      <AnnualCalendar/>
      <Commen/>
      <Faq/>
    </div>
  )
}

export default Aboutpage